import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import { getOrgUserByUserId } from '../api/userApi'
import GlobalLoader from '../components/GlobalLoader'
import * as Sentry from '@sentry/browser'
import { useNavigate } from 'react-router-dom'

const OrgUserContext = createContext({})

export function useOrgUser() {
  return useContext(OrgUserContext)
}

export function OrgUserProvider({ children }) {
  const { getAccessTokenSilently, user, isLoading } = useAuth0()
  const navigate = useNavigate()
  const [orgUser, setOrgUser] = useState({})
  const [toChild, setToChild] = useState({})

  useEffect(() => {
    const intiialize = async () => {
      if (!user) return
      const token = await getAccessTokenSilently({
        audience: 'https://qallix-api',
      })

      const data = await getOrgUserByUserId(token, { userId: user.sub })

      setOrgUser({
        id: user.sub,
        name: data[0].Name,
        email: user.email,
        role: data[0].RoleName,
        orgId: data[0].OrgId,
        orgName: data[0].Organization.OrgName,
        picture: user.picture,
        externalId: data[0].Id,
        isFulfillment: data[0].Organization.Fulfillment,
        orgDisplayName: data[0].Organization.DisplayName,
        DisplayName: data[0].Organization.DisplayName,
        thirdPartyFulfillment: data[0].Organization.ThirdPartyFulfillment,
        appKey: data[0].Organization.AppKey
      })

      setToChild({
        base: data[0].Organization.OrgCurrency,
        to: data[0].LastCurrency,
      })

      const windowPath = window.location.pathname
      if (windowPath == '/' && data[0].Organization.ThirdPartyFulfillment) {
        navigate('/orders3pf')
      }

      Sentry.setUser({ username: user.name })
    }

    intiialize()
  }, [getAccessTokenSilently, user])

  if (isLoading) {
    return <GlobalLoader />
  }
  return (
    <OrgUserContext.Provider value={{ orgUser }}>
      {children}
    </OrgUserContext.Provider>
  )
}